import React from 'react';
import FieldingStatsTable from '../components/FieldingStatsTable';
import { API_ENDPOINTS } from '../config/api';
import { Box } from '@mui/material';

const SeasonFieldingStatsPage = () => {
    return (
        <Box sx={{ p: 3 }}>
            <FieldingStatsTable apiUrl={API_ENDPOINTS.PLAYER_FIELDING_STATS} />
        </Box>
    );
};

export default SeasonFieldingStatsPage; 